import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  @Input()
  public height = 45;

  @Input()
  public width = 150;

  @Input()
  public priority = false;

  @Input()
  public direction: 'horizontal' | 'vertical' = 'horizontal';

  protected get imageSrc(): string {
    switch (this.direction) {
      case 'vertical':
        return '/assets/images/logo-vertical.webp';

      case 'horizontal':
      default:
        return '/assets/images/logo-horizontal.webp';
    }
  }
}
